import React from 'react';
import { motion } from 'framer-motion';

const Lausanne: React.FC = () => {
  return (
    <div className="bg-black text-white pt-32 pb-20">
      
      {/* Header Image */}
      <div className="px-6 lg:px-12 mb-20">
         <motion.h1 
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.8 }}
            className="font-serif text-[12vw] md:text-[10vw] leading-none text-center mb-12"
         >
            LAUSANNE
         </motion.h1>
         <div className="w-full h-[30vh] md:h-[80vh] overflow-hidden grayscale relative">
            <motion.img 
               initial={{ scale: 1 }}
               animate={{ scale: 1 }}
               transition={{ duration: 2, ease: "easeOut" }}
               src="/limohass-ouchy-lausanne.webp" 
               alt="Service Limousine Lausanne Ouchy" 
               className="w-full h-full object-cover" 
            />
         </div>
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-12 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 mb-32">
         <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="text-2xl font-serif leading-relaxed"
         >
            Capitale Olympique, joyau du Léman, centre d'affaires. Votre chauffeur privé à Lausanne.
         </motion.div>
         <motion.div 
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="text-slate-400 font-light text-lg leading-relaxed"
         >
            <p className="mb-6">
            Ancré au cœur de la capitale olympique, LimoHass cultive une connaissance parfaite du terrain. Nous maîtrisons chaque itinéraire pour vous garantir une ponctualité absolue, même aux heures de pointe.
            </p>
            <p>
            Notre spécialité : la liaison Genève Aéroport (GVA) – Lausanne. Profitez d'un confort haut de gamme pour préparer vos séances de travail ou vous ressourcer après votre vol, loin du stress du trafic.
            </p>
         </motion.div>
      </div>

      <div className="border-y border-white/10 py-20 px-6 lg:px-12">
         <div className="max-w-7xl mx-auto">
            <h3 className="text-gold-500 font-mono text-xs tracking-widest mb-12 block">DESSERTE & POINTS D'INTÉRÊT</h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-8">
               {['Beau-Rivage Palace', 'Lausanne Palace', 'Royal Savoy', 'EPFL / UNIL / IMD', 'Musée Olympique', 'Siège du CIO', 'Gare CFF Lausanne', 'Port d\'Ouchy'].map((place, i) => (
                  <motion.div 
                     key={place} 
                     className="group cursor-default"
                     initial={{ opacity: 0, y: 20 }}
                     whileInView={{ opacity: 1, y: 0 }}
                     viewport={{ once: true }}
                     transition={{ delay: i * 0.1 }}
                  >
                     <div className="h-px w-full bg-white/20 mb-4 group-hover:bg-gold-500 transition-colors duration-500"></div>
                     <span className="text-xl font-serif text-white">{place}</span>
                  </motion.div>
               ))}
            </div>
         </div>
      </div>
    </div>
  );
};

export default Lausanne;